module.exports = __webpack_public_path__ + "static/sprinter-2227365f58eaf982287c0adeb0c21447.jpg";